import { TransactionType } from '@profile/src/models';
export const options = [{
  label: 'Claim',
  id: TransactionType.CLAIM.toString()
}, {
  label: 'Deposit',
  id: TransactionType.DEPOSIT.toString()
}];